import {useEffect, useState} from 'react';
import IMG from "../../../constants/image";

const ImageBasic = ({src, className, alt, onClick, handleMouseEnter, height, width}) => {
    const [imageSrc, setImageSrc] = useState(src || IMG.default);

    const handleError = () => {
        setImageSrc(IMG.default);
    };
    const onMouseEnter = () => {
        if (typeof handleMouseEnter === 'function') {
            handleMouseEnter()
        }
    }

    useEffect(() => {
        setImageSrc(src || IMG.default);
    }, [src]);

    return (
        <img
            className={`${className || ''} object-cover`}
            src={imageSrc}
            onClick={onClick}
            width={width}
            height={height}
            onMouseEnter={onMouseEnter}
            alt={alt || "image"}
            onError={handleError}
        />
    );
};

export default ImageBasic;
